<template>
  <BasicLayout>
    <template #actions>
      <BButton v-if='downloadCsvShow' class='btn-icon d-sm-none d-xl-inline' variant='primary' @click='onDownloadCsv'>
        <FeatherIcon icon='DownloadIcon' />
      </BButton>
      <BButton v-if='permissionShow' class='btn-icon d-sm-none d-xl-inline' variant='primary' @click='onPermission'>
        <FeatherIcon icon='KeyIcon' />
      </BButton>
    </template>
    <Content type='user' />
  </BasicLayout>
</template>

<script>
import BasicLayout from '@/components/BasicLayout'
import Content from '@/components/content/Content'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import downloadCsv from '@core/mixins/content/downloadCsv'
import { mapState } from 'vuex'
import { messageChannelEmit } from '@core/utils/message'

export default {
  components: { Content, BasicLayout, FeatherIcon },
  mixins: [downloadCsv],
  data() {
    return {}
  },
  computed: {
    ...mapState('content', ['tabIndex']),
    downloadCsvShow() {
      return this.tabIndex !== 3
    },
    permissionShow() {
      return this.tabIndex === 3
    }
  },
  methods: {
    onPermission() {
      messageChannelEmit('onPermission')
    }
  }
}
</script>

<style scoped></style>
